import { render, staticRenderFns } from "./cookies-warning.vue?vue&type=template&id=45eb3e54"
import script from "./cookies-warning.vue?vue&type=script&lang=js"
export * from "./cookies-warning.vue?vue&type=script&lang=js"
import style0 from "./cookies-warning.vue?vue&type=style&index=0&id=45eb3e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports